import styled from 'styled-components';

import { colors, fontSizes, fontWeights } from '../../theme';
import ButtonPrimitive from '../Button/ButtonPrimitive';

export const TabsContainer = styled.div.attrs({ role: 'tablist' })`
  display: flex;
  gap: 16px;
  align-items: center;
`;

export const TabElement = styled(ButtonPrimitive).attrs({ role: 'tab' })`
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 16px;
  color: ${({ 'aria-selected': ariaSelected }) =>
    ariaSelected ? colors.navy : colors.mouse};
  font-weight: ${fontWeights.medium};
  font-size: ${fontSizes.m};
  white-space: nowrap;
  text-transform: inherit;
  border: 2px solid
    ${({ 'aria-selected': ariaSelected }) =>
      ariaSelected ? colors.navy : 'transparent'};
  border-radius: 12px;
  transition: all 0.3s ease-in-out;

  &:focus-visible {
    color: ${colors.mouse};
    border: 2px solid ${colors.mouse};
    box-shadow: 0 0 0 4px ${colors.sand};
  }

  &:disabled {
    color: ${colors.concrete};
    border-color: transparent;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    color: ${({ 'aria-selected': ariaSelected }) =>
      !ariaSelected && colors.pigeon};
  }
`;
